import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../data/content";

const FAQ = () => (
    <section data-testid="faq-section" className="relative py-20 sm:py-28 bg-slate-50/70 dark:bg-slate-950/60">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-12">
                <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600 dark:text-brand-300 mb-4">FAQ</div>
                <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white">
                    Frequently Asked <span className="text-gradient-brand">Questions</span>
                </h2>
            </motion.div>

            <Accordion type="single" collapsible className="space-y-3">
                {FAQS.map((f, i) => (
                    <AccordionItem
                        key={i}
                        value={`faq-${i}`}
                        data-testid={`faq-item-${i}`}
                        className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 px-5 sm:px-6"
                    >
                        <AccordionTrigger className="text-left font-heading font-semibold text-slate-900 dark:text-white text-base sm:text-lg hover:no-underline">
                            {f.q}
                        </AccordionTrigger>
                        <AccordionContent className="text-slate-600 dark:text-slate-300 text-sm sm:text-base leading-relaxed">
                            {f.a}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    </section>
);

export default FAQ;
